<template>

</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';
// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  nextTick(e=>{
    stravaInit();
    // mapEventInit();
  })
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
  // mapEventClose();
});

const homeMap = computed(()=> store.getters['getHomeMap'] ),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup(),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupAdd = ()=>{
        map.addLayer(layerGroup);
      }

const zoomFn = (event)=>{
  // console.log(event);
  const target = event.target,
        zoom = target.getZoom();
  // console.log(zoom);
  if(zoom >= 8 && !eventHeatMapShowFlag.value){
    store.commit('eventHeatMapShowFlagChange', !eventHeatMapShowFlag.value);
  }
},
mapEventInit = ()=>{
  map && map.on('zoomend', zoomFn);
},
mapEventClose = ()=>{
  map && map.off('zoomend', zoomFn);
}

const eventHeatMapShowFlag = computed(()=> store.getters['eventHeatMapShowFlag'] );

watch(eventHeatMapShowFlag, (newd, old)=>{
  if(newd){
    layerGroupAdd();
  }else{
    layerGroupClose();
  }
}, {
  immediate: true,
})

const tileDefaultZIdex = computed(()=> store.getters['tileDefaultZIdex'] );

const stravaInit = ()=>{
  // 'https://heatmap.ridewithgps.com/v2/map/default/global-23/{z}/{x}/{y}.png'
  // 'https://content-a.strava.com/anon/globalheat/all/red/{z}/{x}/{y}.png'
  L.tileLayer('https://heatmap.ridewithgps.com/v2/map/default/global-23/{z}/{x}/{y}.png', {
    zIndex: tileDefaultZIdex.value,
  }).addTo(layerGroup);
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>